<template>
  <div>
    <section role="modal">
      <div class="modal fade" id="explicacaoModal" tabindex="-1" role="dialog" aria-labelledby="explicacaoModalLabel">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title" id="explicacaoModalLabel">
                Regra de Edição de Dependentes
              </h4>
            </div>
            <div class="modal-body">
              <div class="row row-field" style="padding-bottom: 15px">
                <div class="col-md-12 col-sm-12">
                  <p style="text-align: justify">
                    Para alterações referentes à dependentes do Imposto de Renda, é obrigatório anexar os formulários
                    correspondentes.
                    Os mesmos estão disponíveis na Central do Servidor, na aba <strong>FORMULÁRIOS</strong>.
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <botao estilo="cheio-verde" rotulo="Entendi" icone="ok-modal" dismiss="modal" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="side-modal">
      <side-modal :sides="navs" @cancela="cancela()">
        <template :slot="navs[0].identidade">
          <div class="side-body">
            <div class="row">
              <!--
              <article v-if="dependenteModal.dependenteIR">
                -->
                <article>
                <div class="row row-field">
                  <div class="form-group col-sm-12">
                    <label for="nome">Nome</label>
                    <p>{{ dependenteModal.nome }}</p>
                  </div>
                </div>
                <div class="row row-field">
                  <div class="form-group col-sm-6">
                    <label for="dataNascimento">Data de Nascimento</label>
                    <p>{{ dependenteModal.dataNascimento }}</p>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="sexo">Sexo</label>
                    <p>{{ dependenteSexo }}</p>
                  </div>
                </div>
                <div class="row row-field">
                  <div class="form-group col-sm-6">
                    <label for="tipo">Parentesco</label>
                    <p>{{ dependenteModal.tipo.descricao }}</p>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="dependeteIr">Dependente IR</label>
                    <p>{{ dependenteIr }}</p>
                  </div>
                </div>
              </article>
              <!--
              <form v-else>
                -->
              <form>  
                <div class="row row-field">
                  <field-validation css-class="col-md-12 col-sm-12" label="Nome" field="nome" :status="errors"
                    :custom-errors="apiErrors" :show-icon="false">
                    <input type="text" name="nome" id="nome" class="form-control" v-model="dependenteModal.nome"
                      v-validate="'required|max:45'" data-vv-as="Nome" :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" />
                  </field-validation>
                </div>
                <div class="row row-field">
                  <field-validation css-class="col-sm-6" label="Data de Nascimento" field="dataNascimento"
                    :status="errors" :custom-errors="apiErrors" :show-icon="false" v-if="telaEhMobile">
                    <input type="date" name="dataNascimento" id="dataNascimento" class="form-control"
                      v-model="dependenteModal.dataNascimento" v-validate="'required'"
                      data-vv-as="Data de Nascimento" :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'"/>
                  </field-validation>
                  <field-validation css-class="col-sm-6" label="Data de Nascimento" field="dataNascimento"
                    :status="errors" :custom-errors="apiErrors" :show-icon="false" v-else>
                    <date-picker name="dataNascimento" id="dataNascimento" :config="config"
                      v-model="dependenteModal.dataNascimento" v-validate="'required'"
                      data-vv-as="Data de Nascimento" :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" />
                  </field-validation>
                  <field-validation css-class="col-md-6 col-sm-6" label="Sexo" field="sexo" :status="errors"
                    :custom-errors="apiErrors" :show-icon="false">
                    <select class="form-control" name="sexo" id="sexo" v-model="dependenteModal.sexo"
                      v-validate="'required'" data-vv-as="Sexo" :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'">
                      <option value :selected="true">Escolha</option>
                      <option v-for="sexo in sexos" :value="sexo.name" :key="sexo.name">
                        {{ sexo.displayName.toUpperCase() }}
                      </option>
                    </select>
                  </field-validation>
                </div>
                <div class="row row-field">
                  <field-validation css-class="col-md-6 col-sm-6" label="Parentesco" field="parentesco" :status="errors"
                    :custom-errors="apiErrors" :show-icon="false">
                    <select class="form-control" name="parentesco" v-model="dependenteModal.tipo"
                      v-validate="'required'" data-vv-as="Parentesco" :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'">
                      <option value :selected="true">Escolha</option>
                      <option v-for="grau in graus" :value="grau" :key="grau.id" >
                        {{ grau.descricao }}
                      </option>
                    </select>
                  </field-validation>
                  <div class="form-group col-md-6 col-sm-6">
                    <!-- <label for="dependeteIr">Dependente IR</label>
                    <p class="textoAlinhadoAoInput">{{ dependenteIr }}</p> -->

                    <label for="dependeteIr">Dependente IR</label>
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" v-model="dependenteModal.dependenteIR" id="dependenteIr" :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" class="toggle-switch" />
                        <span class="slider"></span>
                        <span class="text">{{ dependenteModal.dependenteIR ? 'Sim' : 'Não' }}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row row-field">
                  <field-validation css-class="col-md-6 col-sm-6" label="CPF" field="cpf" :status="errors"
                    :custom-errors="apiErrors" :show-icon="false">
                    <input type="text" name="cpf" id="cpf" class="form-control" v-model="dependenteModal.cpfDependente"
                      v-validate="{ required: true, cpf_valido: true }" data-vv-as="CPF" placeholder="Digite o CPF" v-mask="'###.###.###-##'" :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" />
                  </field-validation>
                </div>
              </form>
            </div>
          </div>
          <div class="side-footer">
            <botao tipo="button" estilo="cheio-cinza" rotulo="Cancelar" icone="cancela-modal" @clicado="cancela()" />
            
            <botao tipo="button" estilo="cheio-verde" rotulo="Salvar" icone="ok-modal"
            @clicado="valida(dependenteModal)" :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" />
            <!--
            <botao tipo="button" estilo="cheio-verde" rotulo="Salvar" icone="ok-modal"
              @clicado="valida(dependenteModal)" :disabled="cadastrado.lancamentoPermitido"  v-show="!dependenteModal.dependenteIR" />
              -->
          </div>
        </template>
      </side-modal>
    </section>
    <section role="form">
      <div class="main-container container">
        <div class="row">
          <div class="col-md-12">
            <!-- Filiação -->
            <div class="card card-default">
              <div class="card-content">
                <h4>
                  Filiação
                  <span v-if="cadastrado.mostraMultiplosRegistros">- {{ cadastrado.registro | formataRegistro }}</span>
                </h4>
                <div class="row">
                  <form @keyup.enter="avanca(cadastrado, 'Envio')">
                    <div class="row row-field">
                      <field-validation css-class="col-sm-6" label="Nome da Mãe" field="nomeMae" :status="errors"
                        :custom-errors="apiErrors" :show-icon="false">
                        <input type="text" name="nomeMae" id="nomeMae" class="form-control"
                          v-model="cadastrado.pessoa.filiacao.mae"
                          v-sem-acentos 
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" v-validate="'max:45'" data-vv-as="Nome da Mãe" />
                      </field-validation>
                      <field-validation css-class="col-sm-6" label="Nome do Pai" field="nomePai" :status="errors"
                        :custom-errors="apiErrors" :show-icon="false">
                        <input type="text" name="nomePai" id="nomePai" class="form-control"
                          v-model="cadastrado.pessoa.filiacao.pai" 
                          v-sem-acentos
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" v-validate="'max:45'" data-vv-as="Nome do Pai" />
                      </field-validation>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- Dependentes -->
            <div class="card card-default">
              <div class="card-content">
                <h4>
                  Quadro Familiar&nbsp;
                  <small>
                    <a @click="abreExplicacaoModal()" style="cursor: pointer">(Regra de edição de dependentes)</a>
                  </small>
                </h4>
                <div class="alert alert-warning" role="alert" style="margin-bottom: 15px; text-align: justify;">
                  <i class="fa fa-exclamation-triangle fa-lg"></i>&nbsp; <strong>Atenção:</strong> Para alterações referentes à dependentes do Imposto de Renda, é obrigatório anexar os formulários correspondentes. Os mesmos estão disponíveis na Central do Servidor, na aba <strong>FORMULÁRIOS</strong>.
                </div>
                <div>
                  <div class="alert alert-warning" role="alert" style="text-align: center; cursor: pointer"
                    v-if="cadastrado.pessoa.dependentes.length == 0">
                    <i class="fa fa-flag-o fa-lg"></i>&nbsp; Para incluir um
                    dependente clique em NOVO.
                  </div>
                  <table class="table table-striped table-hover" v-else>
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>CPF</th>
                        <th class="hidden-xs hidden-sm">Data de Nascimento</th>
                        <th class="hidden-xs">Grau de Parentesco</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="dependente of cadastrado.pessoa.dependentes" :key="dependente.id">
                        <td>{{ dependente.nome | tudoMaiusculo }}</td>
                        <td>{{ dependente.cpfDependente | formatarCPF }}</td>
                        <td class="hidden-xs hidden-sm">
                          {{ dependente.dataNascimento | formataData }}
                        </td>
                        <td class="hidden-xs">
                          {{ dependente.tipo.descricao | tudoMaiusculo }}
                        </td>
                        
                        <!--
                        <td class="td-btns td-btns-alone" v-show="dependente.dependenteIR">
                          <botao tipo="button" estilo="vazado-cinza-sm" icone="visualizar" v-tooltip.left="'Visualizar'"
                            @clicado="edita(dependente)" />
                        </td>
                        <td class="td-btns" v-show="!dependente.dependenteIR">
                          <botao tipo="button" estilo="vazado-vermelho-sm" icone="exclui-tabela"
                            v-tooltip.left="'Apagar'" @clicado="exclui(dependente)" />
                          <botao tipo="button" estilo="vazado-cinza-sm" icone="editar-tabela" v-tooltip.right="'Editar'"
                            @clicado="edita(dependente)" />
                        </td>
                        -->
                        <td>
                          <botao tipo="button" estilo="vazado-cinza-sm" icone="visualizar" v-tooltip.left="'Visualizar'"
                          @clicado="edita(dependente)" />
                            <botao tipo="button" estilo="vazado-cinza-sm" icone="editar-tabela" v-tooltip.right="'Editar'"
                            :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" @clicado="edita(dependente)" />
                            <botao tipo="button" estilo="vazado-vermelho-sm" icone="exclui-tabela"
                            :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'"
                            v-tooltip.left="'Apagar'" @clicado="exclui(dependente)" />
                        </td>
                        <!--
                        <td>
                        </td>
                        -->
                      </tr>
                    </tbody>
                  </table>
                  <div class="col-xs-12 footer-controller-inner">
                    <botao tipo="button" estilo="vazado-verde-dir" rotulo="Novo" icone="novo-modal" @clicado="novo()" :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="controller">
      <div class="container footer-controller">
        <div class="row">
          <div class="col-sm-12 col-md-12">
            <botao tipo="button" estilo="vazado-verde-esq" rotulo="Voltar" icone="voltar" @clicado="volta()" />
            <botao tipo="button" estilo="cheio-verde-dir" rotulo="Avançar" icone="avancar" :icone-direita="true"
              @clicado="avanca(cadastrado, 'Envio')" id="vai" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue';
import Botao from '@/components/botao';
import SideModal from '@/components/side-modal';
import moment from 'moment';
import Hash from 'object-hash';
import ArrayHelper from '@/helpers/ArrayHelper';
import DateHelper from '@/helpers/DateHelper';
import StringHelper from '@/helpers/StringHelper';
import NullHelper from '@/helpers/NullHelper';
import Dependente from '@/domain/dependenteRecad/DependenteRecad';
import TiposDependentesService from '@/services/enums/recadTiposDependentesService';

export default {
  name: 'Filiacao',

  data() {
    return {
      cadastrado: this.$store.state.funcionarioCadastrado,
      graus: [],
      dependente: {
        tipo: {
          descricao: '',
        },
      },
      dependentes: [],
      dependenteModal: {
        tipo: {
          descricao: '',
        },
        sexo: '',
      },
      sexos: [
        {
          displayName: 'Masculino',
          name: 'M',
        },
        {
          displayName: 'Feminino',
          name: 'F',
        },
      ],
      navs: [
        {
          titulo: 'Atualização Cadastral',
          subtitulo: 'Dependente',
          subtDetalhe: 'Novo Dependente',
          largura: 600,
          identidade: 'dependente',
          abreProximo: false,
          aberto: false,
        },
      ],
      config: {
        format: 'L',
        useCurrent: false,
        locale: 'pt-br',
        maxDate: moment(new Date()),
        minDate: moment(new Date()).add(-100, 'years'),
      },
      filiacao: {
        mae: '',
        pai: '',
      },
      apiErrors: null,
    };
  },

  computed: {
    dependenteIr() {
      return this.dependenteModal.dependenteIR ? 'SIM' : 'NÃO';
    },
    dependenteSexo() {
      return this.dependenteModal.sexo === 'F' ? 'FEMININO' : 'MASCULINO';
    },
    telaEhMobile() {
      return window.innerWidth <= 768;
    },
    situacaoRecad() {
      return this.$store.getters.getSituacaoRecad;
    },
  },

  methods: {
    abreModal(identidade) {
      this.$emit('abreModal', identidade);
    },
    fechaModal(identidade) {
      this.$emit('fechaModal', identidade);
    },
    abreExplicacaoModal() {
      jQuery('#explicacaoModal').modal('show');
    },
    // Função para validar CPF
    validaCPF(cpf) {
      // Remove caracteres não numéricos
      cpf = cpf.replace(/\D/g, '');
      
      // Verifica se tem 11 dígitos
      if (cpf.length !== 11) return false;
      
      // Verifica se todos os dígitos são iguais
      if (/^(\d)\1+$/.test(cpf)) return false;
      
      // Validação do primeiro dígito verificador
      let soma = 0;
      for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
      }
      let resto = 11 - (soma % 11);
      let dv1 = resto > 9 ? 0 : resto;
      
      // Validação do segundo dígito verificador
      soma = 0;
      for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * (11 - i);
      }
      resto = 11 - (soma % 11);
      let dv2 = resto > 9 ? 0 : resto;
      
      // Verifica se os dígitos verificadores estão corretos
      return (parseInt(cpf.charAt(9)) === dv1 && parseInt(cpf.charAt(10)) === dv2);
    },
    novo() {
      this.navs[0].subtDetalhe = 'Novo Dependente';
      this.abreModal('dependente');
      this.errors.clear();
    },
    valida(dependente) {
      this.$validator.validateAll().then(success => {
        if (success) {
          // Validação adicional do CPF
          if (!this.validaCPF(dependente.cpfDependente)) {
            this.$root.$refs.toastr.e(
              'CPF inválido. Por favor, verifique o número informado.',
              'Atenção'
            );
            return;
          }
          
          if (this.procuraMesmoNome(dependente)) {
            this.$root.$refs.toastr.e(
              'Esse dependente já está cadastrado',
              'Atenção',
            );
            return;
          }
          this.tiraAcentuacaoDependente(dependente);
          this.salva(dependente);
          return;
        }
        this.$root.$refs.toastr.e(
          'Preencha ou corrija os campos em vermelho',
          'Atenção',
        );
      });
    },
    procuraMesmoNome(dependente) {
      if (dependente.index === undefined) {
        return this.cadastrado.pessoa.dependentes.some(
          item => item.nome === dependente.nome,
        );
      }
      return false;
    },
    edita(dependente) {
      this.navs[0].subtDetalhe = dependente.nome;

      dependente.index = this.cadastrado.pessoa.dependentes.indexOf(dependente);
      this.dependenteModal = JSON.parse(JSON.stringify(dependente));
      if (!this.telaEhMobile) {
        this.dependenteModal.dataNascimento = DateHelper.convertDateToPtbr(
          this.dependenteModal.dataNascimento,
        );
      }
      this.abreModal('dependente');
    },
    exclui(dependente) {
      const sentences = [
        {
          id: 1,
          message: 'A exclusão do dependente é apenas em caso de falecimento. Tem certeza que deseja excluir?',
          bold: false,
        },
      ];

      this.$root.$refs.modal.confirm(sentences, {
        yes: () => {
          this.cadastrado.pessoa.dependentes.splice(
            this.cadastrado.pessoa.dependentes.indexOf(dependente),
            1,
          );
          this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
          
          // Atualizar o status para COM_VALIDACAO quando um dependente é excluído
          // Importar o Status
          const Status = require('@/pages/recadastramento/envio/status').default;
          
          // Alteração em dependentes sempre exige validação
          //this.cadastrado.status = Status.COM_VALIDACAO;
          
          // Atualizar o status no store
          //this.$store.dispatch('updateSituacaoRecad', Status.COM_VALIDACAO);
          
          this.$root.$refs.toastr.s('Dependente excluído', 'Sucesso');
        },
        title: 'Deletar Dependente',
      });
    },
    salva(dependente) {
      this.dependente = JSON.parse(JSON.stringify(dependente));
      if (!this.telaEhMobile) {
        this.dependente.dataNascimento = DateHelper.convertPtbrToApiDate(
          this.dependente.dataNascimento,
        );
      }
      const indice = this.dependente.index;
      if (indice >= 0) {
        this.cadastrado.pessoa.dependentes[indice] = this.dependente;
        this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
        this.$root.$refs.toastr.s('Dependente atualizado', 'Sucesso');
        this.fechaModal('dependente');
        this.limpaModal();
      } else {
        this.cadastrado.pessoa.dependentes.push(this.dependente);
        this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
        this.$root.$refs.toastr.s('Novo dependente incluso', 'Sucesso');
        this.fechaModal('dependente');
        this.limpaModal();
      }
    },
    cancela() {
      this.fechaModal('dependente');
      this.limpaModal();
    },
    limpaModal() {
      setTimeout(() => {
        this.dependenteModal = new Dependente();
      }, 600);
    },
    mostraNomeExibicao(valor, lista) {
      if (valor) {
        return lista.find(data => data.name == valor).displayName;
      }
    },
    solicitaConfirmacao(cadastrado, proximoLink, referencia) {
      const sentences = [
        {
          id: 1,
          message: `Identificamos que o ${referencia} está em branco. Deseja manter dessa forma?`,
          bold: false,
        },
      ];

      this.$root.$refs.modal.confirm(sentences, {
        yes: () => {
          referencia === 'nome da mãe'
            ? (cadastrado.nomeMaeNulo = true)
            : (cadastrado.nomePaiNulo = true);
          this.preparaGravaMuda(cadastrado, proximoLink);
        },
        title: 'Confirmar campo em branco',
      });
    },
    preparaGravaMuda(cadastrado, proximoLink) {
      this.tiraAcentuacao(
        cadastrado.pessoa.filiacao,
        cadastrado.pessoa.dependentes,
      );
      this.resetaNulos(cadastrado.pessoa);
      this.setAnexos(cadastrado, this.$store.state.cadastroModelo);
      this.$store.commit('setFuncionarioCadastrado', cadastrado);
      this.$router.push({ name: proximoLink });
    },
    tiraAcentuacao(filiacao) {
      let camposFiliacao = [filiacao.mae, filiacao.pai];
      let indexFiliacao = 0;

      camposFiliacao.map(element => {
        if (StringHelper.verificaCaracterEspecial(element)) {
          camposFiliacao[indexFiliacao] = StringHelper.limpaCaracterEspecial(
            element,
          );
          this.$root.$refs.toastr.w(
            'A Atualização Cadastral não aceita acentos e cedilhas. A aplicação já fez as correções necessárias.',
            'Atenção',
          );
        }
        indexFiliacao++;
      });
      this.cadastrado.pessoa.filiacao.mae = camposFiliacao[0];
      this.cadastrado.pessoa.filiacao.pai = camposFiliacao[1];
    },
    tiraAcentuacaoDependente(dependente) {
      if (StringHelper.verificaCaracterEspecial(dependente.nome)) {
        dependente.nome = StringHelper.limpaCaracterEspecial(dependente.nome);
        this.$root.$refs.toastr.w(
          'A Atualização Cadastral não aceita acentos e cedilhas. A aplicação já fez as correções necessárias.',
          'Atenção',
        );
      }
    },
    setAnexos(cadastrado, original) {
      const filiacao =
        Hash(cadastrado.pessoa.filiacao) != Hash(original.pessoa.filiacao)
          ? true
          : false;
      const dependentes =
        Hash(cadastrado.pessoa.dependentes) != Hash(original.pessoa.dependentes)
          ? true
          : false;
      let documentos = [];

      if (filiacao)
        documentos.push('RG ou Certidão de Nascimento ou Decisão Judicial');
        
      if (dependentes) {
        // Verificar cada dependente alterado ou adicionado
        const novos = cadastrado.pessoa.dependentes.filter(dep => 
          !original.pessoa.dependentes.some(origDep => 
            origDep.id === dep.id && Hash(origDep) === Hash(dep)
          )
        );
        
        // Conjunto para evitar documentos duplicados
        const docsExigidos = new Set();
        
        novos.forEach(dep => {
          const tipoDesc = dep.tipo.descricao.toUpperCase();
          
          if (tipoDesc.includes('COMPANHEIRO') || tipoDesc.includes('COMPANHEIRA')) {
            docsExigidos.add('Escritura de União Estável');
          } else if (tipoDesc.includes('ESPOSO') || tipoDesc.includes('ESPOSA')) {
            docsExigidos.add('Certidão de Casamento Averbada');
          } else {
            docsExigidos.add('Certidão de Nascimento ou de Óbito do parente');
          }
        });
        
        // Adicionar os documentos sem duplicatas
        documentos = [...documentos, ...docsExigidos];
      }

      if (cadastrado.documentosExigidos) {
        const novosDocumentos = documentos.filter(
          item => !cadastrado.documentosExigidos.includes(item),
        );
        cadastrado.documentosExigidos = [
          ...cadastrado.documentosExigidos,
          ...novosDocumentos,
        ];
      } else {
        cadastrado.documentosExigidos = [...documentos];
      }
    },
    volta() {
      this.$router.go(-1);
    },
    avanca(cadastrado, proximoLink) {
      if (!cadastrado.pessoa.filiacao.mae) {
        if (!cadastrado.nomeMaeNulo) {
          this.solicitaConfirmacao(cadastrado, proximoLink, 'nome da mãe');
          return;
        }
      } else {
        cadastrado.nomeMaeNulo = false;
      }
      if (!cadastrado.pessoa.filiacao.pai) {
        if (!cadastrado.nomePaiNulo) {
          this.solicitaConfirmacao(cadastrado, proximoLink, 'nome do pai');
          return;
        }
      } else {
        cadastrado.nomePaiNulo = false;
      }
      this.preparaGravaMuda(cadastrado, proximoLink);
    },
    valoraNulos(pessoa) {
      pessoa.filiacao = NullHelper.valora(pessoa.filiacao, this.filiacao);
    },
    resetaNulos(pessoa) {
      pessoa.filiacao = NullHelper.reseta(pessoa.filiacao, this.filiacao);
    },
    async listaTiposDependentes() {
      try {
        const response = await TiposDependentesService.lista();
        this.graus = await response;
      } catch (error) {
        this.$root.$refs.toastr.e(error.body.message, 'Atenção');
      }
    },
  },

  created() {
    console.log(this.situacaoRecad);
    this.valoraNulos(this.cadastrado.pessoa);
    this.listaTiposDependentes();
    
    // Adicionar regra de validação personalizada para CPF
    this.$validator.extend('cpf_valido', {
      getMessage: field => 'O CPF informado não é válido.',
      validate: value => this.validaCPF(value)
    });
    
    this.$eventBus.$on('salvaAvanca', nomeComponente => {
      this.avanca(this.cadastrado, nomeComponente);
    });
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  beforeDestroy() {
    this.$eventBus.$off('salvaAvanca');
  },
  filters: {
    formatarCPF(cpf) {
      if (!cpf) return '';
      // Remove caracteres não numéricos
      cpf = cpf.replace(/\D/g, '');
      // Aplica a máscara
      return cpf.replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }
  },
  components: {
    Botao,
    SideModal,
  },
};
</script>
<style scoped>
.checkbox {
  position: relative;
}

.toggle-switch {
  display: none;
  /* Esconde o checkbox padrão */
}

.toggle-switch+.slider {
  position: relative;
  display: inline-block;
  width: 60px;
  /* Largura do toggle */
  height: 34px;
  /* Altura do toggle */
  background-color: #ccc;
  /* Cor do fundo */
  border-radius: 34px;
  /* Bordas arredondadas */
  transition: background-color 0.2s;
}

.toggle-switch:checked+.slider {
  background-color: #66bb6a;
  /* Cor quando ativado */
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  /* Altura do círculo */
  width: 26px;
  /* Largura do círculo */
  left: 4px;
  /* Posição inicial do círculo */
  bottom: 4px;
  /* Posição do círculo */
  background-color: white;
  /* Cor do círculo */
  border-radius: 50%;
  /* Círculo arredondado */
  transition: transform 0.2s;
}

.toggle-switch:checked+.slider:before {
  transform: translateX(26px);
  /* Move o círculo para a direita quando ativado */
}

.text {
  margin-left: 10px;
  /* Espaçamento entre o toggle e o texto */
}
</style>


// WEBPACK FOOTER //
// index.vue?641dec41